import IndexPage from '../../../app/components/IndexPage';
import { useSyncPipelineId } from '../../pipelines/hooks/useSyncPipelineId';
import { useHandleSpecialQueryParams } from '../hooks/useHandleSpecialQueryParams';
import PageLoadingSpinner from './PageLoadingSpinner';
import { useLoadColumnWidths } from '../../columnWidths/hooks/useLoadColumnWidths';
import { jsx as _jsx } from "react/jsx-runtime";
const IndexPageContainer = () => {
  // This load is awaited down in the table, but we want to kick it off as early as possible.
  useLoadColumnWidths();
  const hasHandledQueryParams = useHandleSpecialQueryParams();
  const hasSyncedPipeline = useSyncPipelineId();
  if (!hasHandledQueryParams || !hasSyncedPipeline) {
    return /*#__PURE__*/_jsx(PageLoadingSpinner, {});
  }
  return /*#__PURE__*/_jsx(IndexPage, {});
};
export default IndexPageContainer;